import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const AutomatedPlanPage = withSuspense(
	lazy(async () => await import('./automated-plan-page.component')),
	PageLoader,
);
